export const actionType = {
  RESET_FILTERS_START: "FILTERS/RESET_FILTERS_START",
  RESET_FILTERS: "FILTERS/RESET_FILTERS",
  RESET_FILTERS_FAIL: "FILTERS/RESET_FILTERS_FAIL"
};
